import { auth } from 'utils'
import { merge } from 'lodash'
import Vue from 'vue'
import Echo from 'laravel-echo'
import Pusher from 'pusher-js'

export default {
  connect () {

    const options = merge({
      encrypted: process.env.VUE_APP_PUSHER_ENCRYPTED,
      broadcaster: 'pusher',
      key: process.env.VUE_APP_PUSHER_KEY,
      authEndpoint: `${process.env.VUE_APP_API_URL}/broadcasting/auth`,
      auth: {
        headers: {
          'Authorization': `Bearer ${auth.getToken()}`
        }
      },
      namespace: 'Carbon.Events',
      cluster: 'ap1'
    }, process.env.VUE_APP_PUSHER_CONFIG)

    Vue.prototype.$echo = new Echo(options)
  }
}

window.onbeforeunload = () => {
  if (Vue.prototype.$echo) {
    Vue.prototype.$echo.disconnect()
  }
}

// this.pusher = new Pusher('tioryhj8965', {
    // wsHost: window.ws,
    // wsPort: 8080,
    // wssPort: 8080,
    // enabledTransports: ['ws', 'wss'],
    // encrypted: window.encrypted,
    // authEndpoint: window.api + '/broadcasting/auth',
    // auth: {
    //     headers: {
    //       'Authorization': "Bearer " + localStorage.getItem('token')
    //     }
    //   }
// });

// var that = this;
// this.pusher.connection.bind('connected', function() {
//   localStorage.setItem('x-socket-id', that.pusher.connection.socket_id);
// });
